import { render } from "./ListarOperadoresPagamentos.vue?vue&type=template&id=b38fa56c"
import script from "./ListarOperadoresPagamentos.vue?vue&type=script&lang=js"
export * from "./ListarOperadoresPagamentos.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__